module.exports = __webpack_public_path__ + "static/img/23.fa417d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/23.png
// module id = y1sD
// module chunks = 0